__webpack_require__.p = "https://staging.projects.texasmonthly.com/interactive/2020/willie-nelson/";